import type { TradeTeams } from "../../../common/types.ts";
/**
 * Selected assets are what is being negotiated, so they win over exclusions: an asset that is both selected and
 * excluded (Bulk exclude on a whole tab, or an old saved negotiation) stays in the trade and is only removed from the
 * excluded list. Exclusions limit what the counteroffer search may ADD, never what was asked for.
 */
export const respectExclusions = (teams: TradeTeams): TradeTeams =>
	teams.map((team) => ({
		...team,
		pidsExcluded: team.pidsExcluded.filter((pid) => !team.pids.includes(pid)),
		dpidsExcluded: team.dpidsExcluded.filter((dpid) => !team.dpids.includes(dpid)),
	})) as TradeTeams;
